import { render, staticRenderFns } from "./InputBillsList.vue?vue&type=template&id=47c8dcbf&"
import script from "./InputBillsList.vue?vue&type=script&lang=js&"
export * from "./InputBillsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports